import { render, staticRenderFns } from "./ITSubscribe.vue?vue&type=template&id=2b4fe8c8&scoped=true&"
import script from "./ITSubscribe.vue?vue&type=script&lang=js&"
export * from "./ITSubscribe.vue?vue&type=script&lang=js&"
import style0 from "./ITSubscribe.vue?vue&type=style&index=0&id=2b4fe8c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4fe8c8",
  null
  
)

export default component.exports